export const SITE = {
  name: '黑料百科',
  englishName: 'HEILIAO ARCHIVE',
  tagline: '冷门 · 小众 · 早期 · 被删 · 尘封',
  slogan: '被删的、尘封的、没人再提起的，我们把它挖出来',
  intro:
    '黑料百科是一座面向中文互联网记忆的线上档案馆。这里不追热点，只做一件事：把散落在论坛深处、失效链接里、模糊截图中的冷门往事一件件打捞上岸。',
  positioning:
    '我们相信，一个时代的真相往往不在头条里，而藏在被折叠的楼层、被清空的目录和被遗忘的角落。',
  email: 'archive@heiliaobaike.example.com',
  submitEmail: 'tips@heiliaobaike.example.com',
  founded: '2019',
  location: '线上档案馆 · 分布式协作',
  since: '自2019年起持续更新',
  social: '微博 / 即刻 / 小组',
};

export const NAV_LINKS = [
  { label: '首页', to: '/', hash: '' },
  { label: '考古档案', to: '/archive', hash: '' },
  { label: '专题分类', to: '/', hash: 'categories' },
  { label: '关于我们', to: '/about', hash: '' },
  { label: '常见问题', to: '/faq', hash: '' },
];

export const STATS = [
  { label: '收录线索', value: '12,860', unit: '条', icon: 'ri-file-search-line' },
  { label: '考古专题', value: '486', unit: '个', icon: 'ri-folder-open-line' },
  { label: '已还原被删内容', value: '3,200', unit: '篇', icon: 'ri-history-line' },
  { label: '活跃挖掘者', value: '5,400', unit: '人', icon: 'ri-team-line' },
];

export const TIMELINE = [
  {
    year: '2019',
    title: '档案室开张',
    desc: '几位老网友凑在一起，把各自硬盘里存了十几年的截图和存档合并成第一个共享目录。',
  },
  {
    year: '2021',
    title: '「被删档案」专题上线',
    desc: '开始系统整理下架节目、404页面与清空帖子，建立可检索的失效内容索引。',
  },
  {
    year: '2023',
    title: '完成早期论坛索引',
    desc: '把上千个已关停BBS的公开帖子标题与版块结构整理成统一目录，方便按年份回溯。',
  },
  {
    year: '2025',
    title: '开放线索众包',
    desc: '任何网友都可以提交自己保存的老网页、老截图，由档案员交叉核对后入库。',
  },
];

export const TESTIMONIALS = [
  {
    name: '夜航船',
    role: '十年论坛潜水员',
    text: '我一直以为那些年泡过的版块没人记得了，结果在这里看到有人把当年的置顶帖都整理了出来，像翻到自己旧日记。',
    avatar: 'https://readdy.ai/api/search-image?query=portrait%20of%20a%20thoughtful%20young%20chinese%20man%20in%20his%20thirties%20wearing%20a%20dark%20knit%20sweater%2C%20warm%20amber%20side%20lighting%2C%20dim%20archival%20room%20background%2C%20muted%20earthy%20tones%2C%20editorial%20portrait%20photography&width=200&height=200&seq=hlkb-user-01&orientation=squarish',
  },
  {
    name: '拾荒者阿九',
    role: '独立资料整理者',
    text: '整理老网站最怕的就是没有参照。黑料百科的档案编号和交叉引用做得太细了，我写长文时几乎都会来这查一遍。',
    avatar: 'https://readdy.ai/api/search-image?query=portrait%20of%20a%20calm%20chinese%20woman%20in%20her%20late%20twenties%20with%20short%20hair%20and%20round%20glasses%2C%20soft%20golden%20lamp%20light%2C%20dusty%20archive%20shelves%20behind%2C%20warm%20brown%20palette%2C%20editorial%20portrait&width=200&height=200&seq=hlkb-user-02&orientation=squarish',
  },
  {
    name: '深水区',
    role: '亚文化观察者',
    text: '小众圈子的东西最容易被时间冲掉。这里没有猎奇的味道，只有老老实实的考据，这点很难得。',
    avatar: 'https://readdy.ai/api/search-image?query=portrait%20of%20a%20quiet%20chinese%20man%20with%20messy%20hair%20and%20dark%20hoodie%2C%20moody%20amber%20rim%20light%2C%20dark%20textured%20wall%20background%2C%20cinematic%20warm%20tones%2C%20editorial%20portrait%20photography&width=200&height=200&seq=hlkb-user-03&orientation=squarish',
  },
];

export const PRINCIPLES = [
  {
    icon: 'ri-map-pin-2-line',
    title: '只写能找到出处的事',
    desc: '每一条档案都尽量附上原始链接、截图或存档编号，无法交叉验证的内容会明确标注存疑。',
  },
  {
    icon: 'ri-shield-keyhole-line',
    title: '不碰私人生活',
    desc: '我们挖掘的是公开内容与网络文化本身，不收集、不传播任何人的隐私信息。',
  },
  {
    icon: 'ri-archive-2-line',
    title: '保留原始痕迹',
    desc: '错别字、乱码、失效的表情与断裂的排版都被当作时代特征保留，不做美化。',
  },
  {
    icon: 'ri-refresh-line',
    title: '持续更新与修正',
    desc: '档案不是一次写完的。随着新线索出现，旧条目会被标注修订时间与修改说明。',
  },
];